import { apiFetch } from "../../lib/api";

export type ReportType = "available" | "charging" | "waiting" | "offline";

export type ReportCreate = {
  station_id: string;
  charger_id?: string | null;
  report_type: ReportType;
  chargers_available?: number | null;
  wait_time_minutes?: number | null;
  user_count_waiting?: number | null;
  expected_end_time?: string | null;
  cf_turnstile_response?: string | null;
};

export type ReportOut = ReportListItem & {
  helped_count: number;
  is_first_today: boolean;
};

export async function createReport(payload: ReportCreate): Promise<ReportOut> {
  return apiFetch<ReportOut>("/reports", { method: "POST", body: payload });
}

export type FlagReason = "spam" | "incorrect" | "inappropriate";

// Flag is anon-allowed; when a session is available, the call sends the
// access token so the backend can attribute the flag to the user and
// weight the helpful-flags signal accordingly.
export async function flagReport(
  reportId: string,
  reason: FlagReason,
  opts: { authed?: boolean } = {},
): Promise<void> {
  await apiFetch<void>(`/reports/${reportId}/flag`, {
    method: "POST",
    body: { reason },
    auth: opts.authed,
  });
}

export type ReportListItem = {
  id: string;
  station_id: string;
  charger_id: string | null;
  report_type: ReportType;
  chargers_available: number | null;
  wait_time_minutes: number | null;
  user_count_waiting: number | null;
  expected_end_time: string | null;
  created_at: string;
  expires_at: string;
  helpful_count: number;
  flagged: boolean;
  is_anonymous: boolean;
};

export async function listForStation(stationId: string, limit = 10): Promise<ReportListItem[]> {
  return apiFetch<ReportListItem[]>(`/stations/${stationId}/reports?limit=${limit}`);
}
